@if ($token | async; as string) {
  <ng-container [ngTemplateOutlet]="template">
  </ng-container>
} @else {
  <h1>Loading...</h1>
}
